/*eslint sort-keys: "error"*/
export const icons = {
  absence: "briefcase-medical",
  accessRequests: "key",
  actionTags: "exclamation-triangle",
  actions: "tasks",
  adminOnly: "shield-alt",
  approve: "thumbs-up",
  archive: "archive",
  back: "arrow-left",
  billing: "credit-card",
  blogs: "book",
  calendar: "calendar-alt",
  cancel: "times",
  caseStudies: "file-alt",
  check: "check",
  checkForApproval: "thumbs-up",
  checkbox: "check-square",
  chevronDown: "chevron-down",
  chevronLeft: "chevron-left",
  chevronRight: "chevron-right",
  comments: "comments",
  companies: "building",
  companyTags: "tags",
  concern: "flag",
  contracts: "file-signature",
  copy: "copy",
  dashboard: "home",
  date: "calendar",
  delete: "trash",
  deny: "thumbs-down",
  departments: "layer-group",
  details: "info",
  download: "download",
  draft: "file-alt",
  dragHandle: "grip-vertical",
  dueToday: "bell",
  edit: "edit",
  email: "envelope",
  emails: "envelope",
  employeeTags: "tags",
  employees: "users",
  enquiries: "envelope",
  external: "external-link-alt",
  eye: "eye",
  eyeHidden: "eye-slash",
  faqs: "question-circle",
  filePdf: "file-pdf",
  fileWord: "file-word",
  files: "file",
  filter: "filter",
  flowSteps: "project-diagram",
  flowTags: "tags",
  flows: "project-diagram",
  folder: "folder",
  folderOpen: "folder-open",
  forms: "file-alt",
  forward: "arrow-right",
  fourWeekView: "calendar-week",
  fourth: "border-none",
  group: "object-group",
  groupStep: "object-group",
  guidance: "compass",
  hamburgerMenu: "bars",
  handbooks: "book-open",
  helpRequests: "question-circle",
  helpVideos: "video",
  history: "history",
  holidays: "suitcase",
  hoverLoader: "vector-square",
  hrProfiles: "users-cog",
  import: "file-import",
  info: "info",
  knowledgeBase: "book",
  label: "tag",
  letters: "envelope",
  link: "external-link-alt",
  locations: "map-marker-alt",
  logout: "sign-out-alt",
  menu: "ellipsis-v",
  monthlyView: "calendar",
  notes: "sticky-note",
  outcomes: "check-double",
  overtime: "clock",
  overview: "eye",
  plans: "file-invoice-dollar",
  play: "play",
  plus: "plus",
  policies: "shield-alt",
  probation: "clipboard-check",
  publish: "eye",
  question: "question-circle",
  questionSets: "question",
  reload: "sync",
  reminders: "calendar",
  reports: "chart-bar",
  requestApproval: "thumbs-up",
  resolutions: "life-ring",
  restore: "undo",
  results: "briefcase",
  reviews: "star",
  risks: "exclamation-triangle",
  rota: "calendar-alt",
  rotaGroups: "object-group",
  rotaItems: "calendar-check",
  save: "save",
  search: "search",
  sections: "layer-group",
  settings: "cog",
  share: "share-alt",
  sickness: "briefcase-medical",
  sort: "sort",
  sortAsc: "chevron-up",
  sortDesc: "chevron-down",
  startCase: "book",
  stats: "chart-line",
  subCompanies: "sitemap",
  subscriptions: "credit-card",
  summary: "list",
  tasks: "tasks",
  teams: "users-cog",
  text: "font",
  tools: "tools",
  training: "chalkboard-teacher",
  transcribe: "microphone-alt",
  trash: "trash",
  unpublish: "eye-slash",
  updates: "newspaper",
  upload: "upload",
  users: "users",
  warning: "exclamation-triangle",
  website: "globe",
  weekView: "calendar-alt",
  whiteLabelling: "palette",
  x: "times",
}
